"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HCaptcha = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbHCaptcha extends baseLibrary_1.BaseLibrary {
    async load() {
        if (window.HCAPTCHA_SITE_KEY && window.HCAPTCHA_SITE_KEY.trim()) {
            this.instance = new web_ui_framework_1.HCaptcha(window.HCAPTCHA_SITE_KEY);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('HCaptcha: There is no valid HCAPTCHA_SITE_KEY configured');
        }
    }
}
const HCaptcha = new MbHCaptcha();
exports.HCaptcha = HCaptcha;
//# sourceMappingURL=index.js.map